//
//
//
//
//
//

export default {
  name: 'product-card-info-item-loop',
  props: {
    element: Object,
  },
  computed: {
    details() {
      return _.get(this.element, 'mediaTypeDetails', _.get(this.element, 'media_type_details'));
    },
  },
};
